import { Link } from "react-router-dom";
import { Facebook, Youtube } from "lucide-react";
import { useLang } from "@/components/LanguageContext";
import { PAGES, NAV_GROUPS, pathFor } from "@/data/pages";

export default function Footer() {
  const { lang, t } = useLang();

  return (
    <footer data-testid="site-footer" className={`bg-[var(--abs-ink)] text-white mt-24 ${lang === "zh" ? "lang-zh" : ""}`}>
      <div className="max-w-[1480px] mx-auto px-6 lg:px-10 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <Link to={pathFor("home", lang)} className="flex items-center gap-3 mb-5">
              <div className="serif text-3xl">ABS Solutions</div>
            </Link>
            <p className="text-white/70 max-w-sm text-[15px] leading-relaxed">{t.footer.tagline}</p>
            <div className="mt-7 flex items-center gap-3" data-testid="social-links">
              <a href="https://www.facebook.com/297435566783771" target="_blank" rel="noreferrer" aria-label="Facebook" className="h-9 w-9 grid place-items-center border border-white/20 hover:border-[var(--abs-orange)] hover:text-[var(--abs-orange)] transition-colors">
                <Facebook className="h-4 w-4" />
              </a>
              <a href="https://www.tiktok.com/@abs_solutions8" target="_blank" rel="noreferrer" aria-label="TikTok" className="h-9 w-9 grid place-items-center border border-white/20 hover:border-[var(--abs-orange)] hover:text-[var(--abs-orange)] transition-colors text-[11px] font-semibold">TT</a>
              <a href="https://www.youtube.com/@ABSSolutions-88" target="_blank" rel="noreferrer" aria-label="YouTube" className="h-9 w-9 grid place-items-center border border-white/20 hover:border-[var(--abs-orange)] hover:text-[var(--abs-orange)] transition-colors">
                <Youtube className="h-4 w-4" />
              </a>
            </div>
          </div>

          <div className="md:col-span-5 grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <div className="text-[11px] uppercase tracking-[0.18em] text-white/50 mb-4">{t.groupLabels.services}</div>
              <ul className="space-y-2.5 text-[14.5px]">
                {NAV_GROUPS.services.slice(0, 5).map((id) => (
                  <li key={id}><Link to={pathFor(id, lang)} className="text-white/80 hover:text-[var(--abs-orange)]">{t.pageNames[id]}</Link></li>
                ))}
              </ul>
            </div>
            <div>
              <div className="text-[11px] uppercase tracking-[0.18em] text-white/50 mb-4">{t.groupLabels.tax}</div>
              <ul className="space-y-2.5 text-[14.5px]">
                {NAV_GROUPS.tax.map((id) => (
                  <li key={id}><Link to={pathFor(id, lang)} className="text-white/80 hover:text-[var(--abs-orange)]">{t.pageNames[id]}</Link></li>
                ))}
              </ul>
            </div>
            <div>
              <div className="text-[11px] uppercase tracking-[0.18em] text-white/50 mb-4">{t.groupLabels.compliance} · {t.groupLabels.advisory}</div>
              <ul className="space-y-2.5 text-[14.5px]">
                {[...NAV_GROUPS.compliance, ...NAV_GROUPS.advisory, ...NAV_GROUPS.insights].map((id) => (
                  <li key={id}><Link to={pathFor(id, lang)} className="text-white/80 hover:text-[var(--abs-orange)]">{t.pageNames[id]}</Link></li>
                ))}
              </ul>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.18em] text-white/50 mb-4">{t.footer.offices}</div>
            <div className="space-y-5 text-[14.5px] text-white/80">
              <div>
                <div className="text-white font-medium mb-1">Canterbury HQ</div>
                <div>205 Canterbury Road, Canterbury VIC 3126</div>
                <div>+61 3 9826 1316</div>
              </div>
              <div>
                <div className="text-white font-medium mb-1">Brisbane</div>
                <div>Level 19, 10 Eagle Street, Brisbane QLD</div>
                <div>+61 7 3087 3404</div>
              </div>
              <a href="mailto:info@abs-solutions.com.au" className="block text-[var(--abs-orange)] hover:underline">info@abs-solutions.com.au</a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1480px] mx-auto px-6 lg:px-10 py-5 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-[12.5px] text-white/55">
          <div>{t.footer.copyright}</div>
          <div>{t.footer.legal}</div>
        </div>
      </div>
    </footer>
  );
}
